<div class="atp-container container-fluid">
  <div class="atp-container__bg">
    <div class="container atp-container__grid">
      <div
        class="atp-container__info col-xxl-4 col-xl-4 col-lg-4 col-md-12 col-xs-12 offset-xxl-8 offset-xl-8 offset-lg-8"
        style="z-index: 1">
        <div class="row">
          <h2 class="mb-4">Armá tu PC</h2>
          <p class="mb-4">
            Configurá tu nueva PC sin errores de compatibilidad, seleccionando todos los componentes
            que deseás.
          </p>
          <cgw-action-button [data]="moreButton"></cgw-action-button>
        </div>
      </div>
    </div>
  </div>
</div>
